import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const ExPieChart2Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: ['feedback-count'],
  },
];
